import axios from 'axios';

import {
	getStoredRoleData,
	getStoredTokenData
} from '../store/auth-context';
import { API_CONSTANTS } from './apiConstants';

const API_URL = API_CONSTANTS.API_URL;

const STUDIES = [
	{
		id: 's1',
		pi: { username: 'raul' },
		title: 'study 1',
		status: 'SUBMITTED_FOR_ANALYSIS',
		type: '',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's2',
		pi: { username: 'raul' },
		title: 'study 2',
		status: 'READY FOR REVIEW',
		type: '',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	},
	{
		id: 's3',
		pi: { username: 'raul' },
		title: 'study 3',
		status: ' STUDY COMPLETED',
		type: 'amedment',
		sponsor: 'phizer',
		documentsNumber: '03'
	}
];

export const fetchStudiesDummy = async () => {
	return Promise.resolve({ studies: STUDIES });
};

export const fetchStudies = async (
	pageNumber,
	currentOption,
	q
) => {
	const role = getStoredRoleData().role.toLocaleLowerCase();
	const token = getStoredTokenData().token;
	let fetchStudiesReqUrl = `api/${role}/studies?page=${pageNumber}`;
	if (q) {
		fetchStudiesReqUrl += `&search=${q}`;
	}
	return axios.get(`${API_URL}/${fetchStudiesReqUrl}`, {
		headers: {
			token: `${token}`
		},
		params: {
			numofStudies: 8,
			status: `${currentOption}`
		}
	});
};

export const getStudiesCompletedAndArchived = async () => {
	const role = getStoredRoleData().role.toLocaleLowerCase();
	const token = getStoredTokenData().token;
	return axios.get(
		`${API_URL}/api/${role}/get-archived-and-completed`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getStudyById = async (studyId) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	const confirmedRole = role === 'hospital' ? 'QA' : role; 
	return axios.get(
		`${API_URL}/api/${confirmedRole}/study/${studyId}`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getArchiveStudies = async () => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.get(
		`${API_URL}/api/${role}/archived-studies/`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getFormOptionslist = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/qa/dropdowns-list`, {
		headers: {
			token: `${token}`
		}
	});
};

export const getCancerTypes = async () => {
	const token = getStoredTokenData().token;
	return axios.get(`${API_URL}/api/qa/get-cancer-types`, {
		headers: {
			token: `${token}`
		}
	});
};

export const getCancerSubtypes = async (type) => {
	const token = getStoredTokenData().token;
	return axios.get(
		`${API_URL}/api/qa/get-cancer-subtypes/${type}`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getCancerStages = async (type, subtype) => {
	const token = getStoredTokenData().token;
	return axios.get(
		`${API_URL}/api/qa/get-cancer-stages/${type}/${subtype}`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getBios = async (type, subtype, stage) => {
	const token = getStoredTokenData().token;
	return axios.get(
		`${API_URL}/api/qa/get-bios/${type}/${subtype}/${stage}`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const getTimeOptionslist = async (
	studyId,
	tableIndex
) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.get(
		`${API_URL}/api/${role}/row-dropdown/${studyId}/${tableIndex}`,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const addStudy = async (studyData) => {
	const token = getStoredTokenData().token;
	return axios.post(`${API_URL}/api/qa/add`, studyData, {
		headers: {
			token: `${token}`
		}
	});
};

export const addAmendment = async (studyData) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/qa/new-amendment`,
		studyData,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const addNewRow = async (rowData) => {
	const token = getStoredTokenData().token;
	const role = getStoredRoleData().role.toLocaleLowerCase();
	return axios.post(
		`${API_URL}/api/${role}/add-row`,
		rowData,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const uploadFile = async (signedUrl, fileBlob) => {
	let options = {
		headers: {
			'Content-Type': fileBlob.type
		}
	};

	return axios.put(signedUrl, fileBlob, options);
};

export const getFileUrl = (fileName, qamId) => {
	const token = getStoredTokenData().token;
	let reqUrl = `api/get-file-url/${fileName}`;
	if (qamId) {
		reqUrl += `/${qamId}`;
	}
	return axios.get(
		`${API_URL}/${reqUrl}`,

		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const signDocuments = async (documents) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/qa/protocols`,

		documents,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const createBillingGridRequest = async (
	protocolInfo
) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/qa/create-billing-grid`,

		protocolInfo,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const editStudyInformationForm = async (
	studyData
) => {
	const token = getStoredTokenData().token;
	return axios.post(
		`${API_URL}/api/qa/approve`,
		studyData,
		{
			headers: {
				token: `${token}`
			}
		}
	);
};

export const fetchDoctors = async (hospitalId, qaOrPi, token) => {
	try {
		const response = await axios.get(
			`${API_URL}/api/hospital/doctors/${hospitalId}/${qaOrPi}`,
			{
				headers: {
					token: token
				}
			}
		);
		return response.data.doctors;
	} catch (error) {
		console.error('Error fetching doctors:', error);
		throw error;
	}
};

export const fetchStudiesByDoctor = async (role, doctorId, page, token) => {
	try {
		//const response = await axios.get(`${API_URL}/api/hospital/studies/qa/65f86203a72f8899049ada7a/1`);
		const response = await axios.get(
			`${API_URL}/api/hospital/studies/${role}/${doctorId}/${page}`,
			{
				headers: {
					token: token
				}
			}
		);

		return response.data.studies;
	} catch (error) {
		console.error('Error fetching studies:', error);
		throw error;
	}
};
